<script>
import MicrosoftIcons from '../../../assets/images/logomicrosoft.png'
import SocialIcons from '../../../assets/images/logosocial.png'

export default {
  page: {
    title: 'Login',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  // eslint-disable-next-line
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      microsoftIcons: MicrosoftIcons,
      socialIcons: SocialIcons,
    }
  },
  computed: {},
  watch: {},
  mounted: function() {
    this.$nextTick(function() {
      this.init()
    })
  },
  created: function() {},
  methods: {
    init() {},
    loginSocial() {
      this.$store.dispatch('auth/logIn')
    },
    loginMicrosoft() {
      this.$store.dispatch('auth/logInMs')
    },
  },
}
</script>

<template src="./login.html"></template>
